import CategoriesList from './CategoriesList';

export default CategoriesList;
